<template>
	<div>
		<transition name="fade" appear>

			<div class="dashboard">
				<main-menu></main-menu>

				<div class="dashboard__main">

					<top-menu></top-menu>

					<transition name="fade" mode="out-in">
						<router-view></router-view>
					</transition>

				</div>
			</div>

		</transition>
	</div>
</template>

<script>
	import MainMenu from './partials/mainmenu.vue';
	import TopMenu from './partials/topmenu.vue';
    import {mapGetters} from 'vuex';

    export default {
        name: "Dashboard",
		components:{
            'main-menu':MainMenu,
			'top-menu':TopMenu,
		},
        created(){
            this.$store.dispatch('getUser');
        }

    }
</script>

<style scoped>

</style>